export default "__VITE_ASSET__390481f5__"